module.exports = __webpack_public_path__ + "dbc9c75cdab163b6e6df728b9415f95a.gif";